import type { MenuItemProps } from '@mui/material';
import { MenuItem } from '@mui/material';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

type MenuItemLinkProps = Omit<MenuItemProps<'a'>, 'component'>;

const UnwrappedMenuItemLink = forwardRef<HTMLAnchorElement, MenuItemLinkProps>((props, ref) => (
  <MenuItem ref={ref} component="a" sx={{ textTransform: 'none' }} {...props} />
));

export const MenuItemLink = createLink(UnwrappedMenuItemLink);
